import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/lsa'

Styxie.Initializers.LsaLaunchAgent = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/lsa/launch_agent/index.vue')
    createVueApp(Component, { props, sidebar })
  }
}
